import React from "react";
import { SearchBox } from "@quintype/components";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash/get";
import { func } from "prop-types";

import { OPEN_SEARCHBAR } from "../../../store/actions";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";

import "./navbar-search.m.css";
import { staticTexts } from "../../../utils/translate";

const DrawForm = ({ children }) => {
  const lang = useSelector((state) => get(state, ["qt", "config", "publisher-attributes", "lang"], ""));
  return [
    <label styleName="search__form-label" htmlFor="searchForm" key="1">
      {children}
    </label>,
    <button aria-label="search-button" type="submit" styleName="search__form-submit" key="2">
      {staticTexts(lang).search}
    </button>,
  ];
};

DrawForm.propTypes = {
  children: func,
};

const NavbarSearch = () => {
  const dispatch = useDispatch();
  const isSearchBarOpen = useSelector((state) => get(state, ["isSearchBarOpen"], false));
  const isHamburgerMenuOpen = useSelector((state) => get(state, ["isHamburgerMenuOpen"], false));
  const lang = useSelector((state) => get(state, ["qt", "config", "publisher-attributes", "lang"], ""));

  const toggleSearchForm = () => {
    dispatch({
      type: OPEN_SEARCHBAR,
      isSearchBarOpen: !isSearchBarOpen,
    });
    document.getElementById("searchForm").focus();
  };

  const closeSearchBar = () => {
    dispatch({
      type: OPEN_SEARCHBAR,
      isSearchBarOpen: false,
    });
  };

  const formStyle = {
    transform: isSearchBarOpen ? "translate(0, 0)" : "",
    width: "360px",
    height: "80px",
    top: "100%",
  };

  return (
    <>
      <button
        aria-label="search-button"
        styleName="search-btn"
        className="search-btn"
        onClick={() => toggleSearchForm()}
        style={{ paddingLeft: isHamburgerMenuOpen ? "8px" : "" }}
      >
        <SvgIconHandler type="search" width="24" height="24" viewBox="0 0 24 24" />
      </button>
      <div styleName="search-form" style={formStyle}>
        <SearchBox
          styleName="search-box"
          template={DrawForm}
          inputId="searchForm"
          inputClassName="search__form-input"
          onSubmitHandler={() => closeSearchBar()}
          onEscape={() => closeSearchBar()}
          placeholder={staticTexts(lang).typeHere}
        />
      </div>
    </>
  );
};

export { NavbarSearch };
